import api from './api';

export const machineryEventTypeService = {
  async getEventTypes() {
    const response = await api.get('/machinery/event-types');
    return response.data;
  },

  async createEventType(data) {
    const payload = typeof data === 'string' ? { name: (data || '').trim(), category: 'informativo' } : { name: (data.name || '').trim(), category: data.category || 'informativo' };
    const response = await api.post('/machinery/event-types', payload);
    return response.data;
  },

  async updateEventType(id, data) {
    const payload = typeof data === 'string' ? { name: (data || '').trim() } : { name: (data.name || '').trim(), category: data.category };
    const response = await api.put(`/machinery/event-types/${id}`, payload);
    return response.data;
  },

  async deleteEventType(id) {
    const response = await api.delete(`/machinery/event-types/${id}`);
    return response.data;
  },
};
